import React, { useEffect } from "react";
import Header from "../Header/Header.js";
import Footer from "../Footer/Footer.js";
import banner from "./assets/banner.webp";
import bg from "./assets/bg.webp";
import paths from "./course.js";
import "./course.css";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function Courses() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCardClick = (link) => {
    navigate(link);
  };
  return (
    <div>
      <Helmet>
        <title>ISKCON Vijayawada Courses – Learn Vedic Wisdom & Bhakti</title>
        <meta
          name="description"
          content="Explore ISKCON Vijayawada’s spiritual courses including Gita study, Bhakti Sastri, yoga, and leadership training rooted in timeless Vedic teachings."
        />
        <meta
          name="keywords"
          content="ISKCON Vijayawada courses, Iskcon vijayawada Gita study programs,Iskcon vijayawada Bhakti classes, Vedic education ISKCON vijayawada"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="ISKCON Vijayawada Courses – Learn Vedic Wisdom & Bhakti"
        />
        <meta
          property="og:description"
          content="Explore ISKCON Vijayawada’s spiritual courses including Gita study, Bhakti Sastri, yoga, and leadership training rooted in timeless Vedic teachings."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/courses"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="ISKCON Vijayawada Courses – Learn Vedic Wisdom & Bhakti"
        />
        <meta
          name="twitter:description"
          content="Explore ISKCON Vijayawada’s spiritual courses including Gita study, Bhakti Sastri, yoga, and leadership training rooted in timeless Vedic teachings."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.iskconvijayawada.org/courses" />
      </Helmet>

      <Header />
      {/* Banner Section */}
      <div className="w-full relative">
        <img loading="lazy" src={banner} alt="Overview on temple preaching services" className="w-full " />
        <div className="absolute w-[40%]  bg-[#c61d21]/50 top-[15%] md:top-[30%]  left-[30%] flex justify-center items-center p-4 ">
          <h2 className="text-center text-white text-2xl md:text-9xl font-normal font-['DM Serif Display'] m-0 uppercase ">
            Courses
          </h2>
        </div>
      </div>

      <div
        className="main"
        style={{
          background: `url(${bg})`,
          backgroundSize: "cover",
        }}
      >
        <div className="courses-section-heading">
          <h1 className="courses-heading">
            Spiritual Courses – Learn Krishna Consciousness Step-by-Step
          </h1>
          <h2 className="courses-subheading">
            Enroll in Gita Classes, Bhakti Sastri & More
          </h2>
        </div>

        <div className="w-[85%] mx-auto text-center relative flex flex-col justify-center items-center subheading">
          <h3 className="text-black text-xl md:text-[42px] md:font-normal font-['DM Serif Display'] font-bold ">
            PROGRESS ON THE PATH
            <br />
          </h3>
          <p className="text-center md:text-center text-black text-base md:text-3xl font-normal font-['Open Sans'] md:leading-[44px] m-0">
            No matter where you are on your spiritual journey we offer a wide
            cross-section of seminars and courses to help you progress on the
            path of Bhakti and Krishna Consciousness. Our courses are all free
            of cost and open to all.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 box gap-5 md:gap-14">
          {paths.map((path) => (
            <div
              onClick={() => handleCardClick(path.link)}
              className="bg-[#f6f2e8] rounded-xl md:rounded-[25px] shadow-[-1px_6px_10.6px_7px_rgba(0,0,0,0.25)] cursor-pointer transition-transform hover:scale-105"
              key={path.id}
            >
              <img
                loading="lazy"
                src={path.Image}
                alt="Overview on temple preaching services"
                className="w-[110%]"
              />
              <p className="text-[#c61d21] text-base md:text-4xl font-semibold font-['Poppins'] content m-0">
                {path.title}
              </p>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Courses;
